/* eslint-disable max-len */
import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props}>
    <path
      d="M18.305 7.571c.807 1.333 1.152 2.892.981 4.439v.888A5.31 5.31 0 0 0 20 15.561M8.58 11.122c0-.942.376-1.845 1.045-2.511a3.58 3.58 0 0 1 5.047 0 3.54 3.54 0 0 1 1.045 2.511v.888a8.85 8.85 0 0 0 1.784 5.327m-5.353-6.215v1.776c-.003 2.539.776 5.017 2.231 7.102M8.58 14.673A15.92 15.92 0 0 0 10.186 20m-4.372-1.776a19.44 19.44 0 0 1-.803-6.215v-.888c-.003-1.248.324-2.476.949-3.558a7.12 7.12 0 0 1 2.611-2.607c1.086-.626 2.318-.956 3.572-.956s2.487.327 3.574.952"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
